import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import SearchInput from '../components/Search-input';
import {FormattedMessage} from 'react-intl';
import {navigateBack} from '../services/history';
import {execBI} from '../services/bi-events-manager';
import ALink from '../components/ALink';

const isHome = location => {
  return location.pathname === '/';
};

const handleGoBack = (ev) => {
  ev.preventDefault();
  execBI('BACK_LINK_CLICK');
  navigateBack();
};

class HeaderBig extends React.Component {

  render() {
    const {pendingApps, location} = this.props;
    const locationQuery = location.query.q || '';
    const home = isHome(location);

    return (
      <div className={classNames('header', {'header-inner': this.props.isCategory}, 'vertical-collections-enabled')}>

        <div className="top-bar-container">
          <div className="top-bar section section-pad">
            <SearchInput search={locationQuery} categories={this.props.categories} isHome={home}/>

            <div className="navigation-container">
              {home ? '' :
              <ALink to={'/'} className="back" onClick={handleGoBack}>
                <FormattedMessage id="navigation.button.back"/>
              </ALink> }

              <ALink to={'/categories/'} className="categories" onClick={() => execBI('CATEGORIES_POPUP_LINK_CLICK')}>
                {pendingApps.length ? <span className="notification-badge">{pendingApps.length}</span> : ''}
                <FormattedMessage id="navigation.button.categories"/>
              </ALink>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

HeaderBig.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  pendingApps: PropTypes.array.isRequired,
  isCategory: PropTypes.bool,
  categories: PropTypes.array.isRequired
};


function mapStateToProps(state) {
  return {
    pendingApps: state.appsByType.pendingInMarket.items,
    categories: state.categories.menu.items
  };
}

export default connect(mapStateToProps)(HeaderBig);



// WEBPACK FOOTER //
// ./containers/Header-big.js